import React from 'react'
import { ModalFooter } from 'reactstrap'
import { ModalBody } from 'reactstrap'
import { ModalHeader } from 'reactstrap'
import { Modal } from 'reactstrap'
// import { LeadDetailsModel } from '../../Models/Lead/LeadDetails'
// import { MessageThread } from '../../Models/MessageCenter/MessageThread'
// import { TodoModal } from '../../Models/NotificationsModel/NotificationModel'
// import { Question } from '../../Models/Shared/QuestionaryModule/Question'
import MessageChatWindowFC from './MessageChatWindowFC'
import MessageChatWindowHeaderFC from './MessageChatWindowHeaderFC'
import MessageTextAreaFC from './MessageTextAreaFC'
import { MessageThread } from '../../../models/QuestionarieMCModal'
import { LeadDetailsModel } from '../../../models/Lead/LeadDetails'
import { TodoModal } from '../../layout/Leads/Notifications/NotificationModal'

interface IMessageCenterModal {
  disableforsuperuser?: boolean
  messageModal: boolean;
  toggleMessageModal: () => void;
  refreshCounter: number;
  messageThread?: MessageThread | null;
  messageSend?: () => void;
  clientDetails?: LeadDetailsModel;
  question?: any;
  clientUserId?: string;
  todo?: TodoModal;
  setRefreshCounter?: React.Dispatch<React.SetStateAction<number>>;
  getMessageThreads?: (contextId?: string) => void;
  setViewTodo?: 
    (React.Dispatch<React.SetStateAction<TodoModal | null>>) |
    ((element: TodoModal | null) => void);
}

const MessageCenterModal = (props: IMessageCenterModal) => {
  return (
    <Modal 
      isOpen={props?.messageModal} 
      toggle={props?.toggleMessageModal} 
      size="size" 
      className='message-modal'
    >
      <ModalHeader toggle={props?.toggleMessageModal}>
        <MessageChatWindowHeaderFC 
          messageThread={props?.messageThread} 
        />
      </ModalHeader>
      <ModalBody className="message-chat-container">
        <MessageChatWindowFC 
          messageThread={props?.messageThread} 
          refreshCounter={props?.refreshCounter} 
        />
      </ModalBody>
      <ModalFooter>
        <MessageTextAreaFC  
          messageThread={props?.messageThread} 
          messageSend={props?.messageSend} 
          clientDetails={props?.clientDetails} 
          question={props?.question} 
          clientUserId={props?.clientUserId}
          todo={props?.todo}
          setRefreshCounter={props?.setRefreshCounter}
          getMessageThreads={props?.getMessageThreads}
          setViewTodo={props?.setViewTodo}
          disableforsuperuser={true}
        />
      </ModalFooter>
    </Modal> 
  )
}

export default MessageCenterModal